import { TextField } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../app-context';
import Notification from '../../feature/notification/notification.component';
import { saveNotification } from '../../feature/notification/notification_service';
import { EMPTY_STRING, FEATURE_NAME } from '../../components/constants/constants';
import './admin-notification.styles.scss';
import { testNotification } from './notification.service';

const AdminNotification = (props) => {
  const initData = {
    userId: EMPTY_STRING, title: EMPTY_STRING, featureName: EMPTY_STRING, url: EMPTY_STRING, imageUrl: EMPTY_STRING, description: EMPTY_STRING
  };
  const [formData, updateFormData] = useState(initData);
  const [currRow, setCurrRow] = useState(initData);
  const appContext = useContext(AppContext);

  const saveNotificationData = (event) => {
    saveNotification(formData).subscribe({
      next: (response) => {
        updateFormData(initData);
        setCurrRow(response.data);
        appContext.setSuccessMessage(response.message);
      }});
  }

  const sendNotification = (e) => {
    testNotification(formData).subscribe({
      next: (response) => {
        appContext.setDialogMessage(response.message);
      }, error: (error) => {
        appContext.setErrorMessage(error.message);
      }
    });
  };

  const handleChange = (e) => {
    updateFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const getFormPanel = () => {
    return (
      <form noValidate autoComplete="off">
        <div className="controlBox">
          <div className="supportControl" fullWidth>
            <TextField name="featureName" value={formData.featureName} select label="Feature Name" variant="outlined" size="small" fullWidth
              onChange={handleChange}>
              {FEATURE_NAME.map((featureName) => (
                <MenuItem key={featureName} value={featureName}>
                  {featureName}
                </MenuItem>
              ))}
            </TextField>
          </div>
          <div className="supportControl">
            <TextField name="userId" label="Mobile Number" required variant="outlined" size="small" fullWidth
              value={formData.userId} onChange={handleChange}
            />
          </div>
          <div className="supportControl">
            <TextField name="title" label="Title" required variant="outlined" size="small" fullWidth
              value={formData.title} onChange={handleChange}
            />
          </div>
          <div className="admin-part-control">
            <TextField name="url" label="Notification URL" variant="outlined" size="small" fullWidth
              value={formData.url} onChange={handleChange}
            />
          </div>
          <div className="admin-part-control">
            <TextField name="imageUrl" label="Notification Image" variant="outlined" size="small" fullWidth
              value={formData.imageUrl} onChange={handleChange}
            />
          </div>
          <div className="supportControl">
            <TextField name="description" label="Description" required multiline rows={3} variant="outlined" size="small" fullWidth
              value={formData.description} onChange={handleChange}
            />
          </div>
          <div className="supportControl sendButton">
            <Button type="button" variant="contained" color="primary" onClick={sendNotification}>
            Send Notification
            </Button>
          </div>
          <div className="supportControl sendButton">
            <Button type="button" variant="contained" color="secondary" onClick={saveNotificationData}>
              Save
            </Button>
          </div>
        </div>
      </form>
    );
  }
  
  const onEditNotifications = (evt) => {
    updateFormData(evt);
  }

  return (
    <div className="notification-main">
      <div className="notification-title">Notifications</div>
      {getFormPanel()}
      <Notification role="admin" row={currRow} onEdit={(e) => {onEditNotifications(e)}}/>
    </div>
  );
}

export default AdminNotification;